import React, { useState, useContext, useEffect, useRef } from "react";
import { AppContext } from '../application/provider';
import { Table } from "reactstrap";
import Loader from '../components/Loader/Loader';
import SeguimientoBoletaService from "../axios_services/seguimientoboleta.service";
import { ButtonSearch, ButtonInsert, ButtonUpdate } from '../components/Buttons/Buttons';
import ModalSeguimientoBoleta from '../components/Modal/ModalSeguimientoBoleta';
import "./SeguimientoBoletaProspecto.css";

function SeguimientoBoletaProspecto() {
    const [state] = useContext(AppContext);
    const perfilId = Number(state.user.perfil_id);
    const usuarioId = Number(state.user.usuario_id);
    const isEditor = [3, 4, 6, 8, 23, 27].includes(perfilId);
    const isAnalista = [4, 27].includes(perfilId);
    const isPowerEditor = [6, 8, 23].includes(perfilId);
    const now = new Date();
    const [isLoading, setIsLoading] = useState(false);
    const [registros, setRegistros] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalInitialData, setModalInitialData] = useState({ supervisorId: '', gestorId: '', initialDnis: [] });

    // Filters
    const [fechaSeleccionada, setFechaSeleccionada] = useState(() => {
        const now = new Date();
        return now.toLocaleDateString('en-CA');
    });
    const [filterSupervisor, setFilterSupervisor] = useState('');
    const [appliedFilters, setAppliedFilters] = useState({ fecha: fechaSeleccionada, supervisor: '' });

    const initialFetchDone = useRef(false);

    // Catalogos
    const supervisores = state.user.personal.filter(p => Number(p.perfil_id) === 3);
    const canalCaptacion = state.catalogos.tipos.filter(t => Number(t.categoria_id) === 14);

    const loadRegistros = async (supervisorId, fecha) => {
        setIsLoading(true);
        try {
            const data = await SeguimientoBoletaService.getSeguimientoBoleta({
                supervisor_id: supervisorId,
                fecha_inicio: fecha,
                fecha_fin: fecha
            });
            setRegistros(data);
            setAppliedFilters({ fecha: fecha, supervisor: supervisorId });
        } catch (error) {
            console.error("Error loading records:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (!initialFetchDone.current) {
            loadRegistros(filterSupervisor, fechaSeleccionada);
            initialFetchDone.current = true;
        }
    }, []);

    const handleSearchClick = () => {
        loadRegistros(filterSupervisor, fechaSeleccionada);
    };

    const handleNewRecord = () => {
        setModalInitialData({ supervisorId: '', gestorId: '', dni: '' });
        setIsModalOpen(true);
    };

    const handleActionClick = (supervisorId, gestorId) => {
        const gestorRestros = registros.filter(r => Number(r.gestor_id) === Number(gestorId));
        setModalInitialData({
            supervisorId: supervisorId,
            gestorId: gestorId,
            initialDnis: gestorRestros
        });
        setIsModalOpen(true);
    };

    const handleSaveRecord = async (data) => {
        try {
            await SeguimientoBoletaService.registrarBoleta(data);
            alert('Registro guardado correctamente');
            loadRegistros(appliedFilters.supervisor, appliedFilters.fecha);
        } catch (error) {
            const errorMsg = error.response?.data?.detail || error.response?.data?.error || 'No se pudo guardar el registro';
            alert(errorMsg);
            throw error;
        }
    };

    const getRevisionClass = (revision) => {
        if (Number(revision) === 1) return 'revision-verde';
        if (Number(revision) === 2) return 'revision-rojo';
        return '';
    };

    return (
        <div className="caja-flujo-container">
            <div>
                <h1>SEGUIMIENTO DE BOLETAS DIARIAS</h1>
            </div>

            <div className="filtros">
                <div className="campo-fecha">
                    <label htmlFor="fechaSeleccionada">Fecha:</label>
                    <input
                        id="fechaSeleccionada"
                        type="date"
                        value={fechaSeleccionada}
                        onChange={(e) => setFechaSeleccionada(e.target.value)}
                    />
                </div>
                {(!isAnalista && perfilId !== 3) && (
                    <div className="campo-fecha">
                        <label htmlFor="supervisor">Jefe de gestión:</label>
                        <select
                            id="supervisor"
                            className="form-control"
                            value={filterSupervisor}
                            onChange={(e) => setFilterSupervisor(e.target.value)}
                        >
                            <option value="">Todos los supervisores</option>
                            {supervisores.map(s => (
                                <option key={s.usuario_id} value={s.usuario_id}>
                                    {s.nombre_completo_usuario}
                                </option>
                            ))}
                        </select>
                    </div>
                )}
            </div>

            <div className="mt-3">
                <ButtonSearch onClick={handleSearchClick} isLoading={isLoading} />
            </div>

            {
                isLoading ? <Loader /> : (
                    <div className="table-container">
                        <Table>
                            <thead>
                                <tr>
                                    {(!isAnalista && perfilId !== 3) && <th>JEFE DE GESTIÓN</th>}
                                    <th>ANALISTA DE CRÉDITO</th>
                                    <th>PROSPECTO</th>
                                    <th>CANAL CAPTACIÓN</th>
                                    {(isPowerEditor || (isEditor && appliedFilters.fecha === now.toLocaleDateString('en-CA'))) && <th>ACCIONES</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {(() => {
                                    const currentYear = now.getFullYear();
                                    const currentMonth = now.getMonth();

                                    const [year, month, day] = appliedFilters.fecha.split('-').map(Number);
                                    const isCurrentMonth = year === currentYear && (month - 1) === currentMonth;

                                    const gestoresAVisualizar = state.user.personal
                                        .filter(p => {
                                            if (isAnalista) return Number(p.usuario_id) === usuarioId;
                                            return (Number(p.perfil_id) === 4 || Number(p.perfil_id) === 27) &&
                                                (perfilId === 3 ? Number(p.supervisor_id) === usuarioId : (!appliedFilters.supervisor || Number(p.supervisor_id) === Number(appliedFilters.supervisor)));
                                        })
                                        .sort((a, b) => {
                                            const supA = state.user.personal.find(p => Number(p.usuario_id) === Number(a.supervisor_id))?.nombre_completo_usuario || '';
                                            const supB = state.user.personal.find(p => Number(p.usuario_id) === Number(b.supervisor_id))?.nombre_completo_usuario || '';
                                            if (supA !== supB) return supA.localeCompare(supB);
                                            return a.nombre_completo_usuario.localeCompare(b.nombre_completo_usuario);
                                        });

                                    if (isCurrentMonth) {
                                        return gestoresAVisualizar.map(g => {
                                            const regsGestor = registros.filter(r => Number(r.gestor_id) === Number(g.usuario_id));
                                            const supervisorName = (state.user.personal.find(p => Number(p.usuario_id) === Number(g.supervisor_id))?.nombre_completo_usuario || 'N/A').toUpperCase();
                                            const gestorName = g.nombre_completo_usuario.toUpperCase();

                                            if (regsGestor.length === 0) {
                                                return (
                                                    <tr key={`empty-${g.usuario_id}`}>
                                                        {(!isAnalista && perfilId !== 3) && <td>{supervisorName}</td>}
                                                        <td>{gestorName}</td>
                                                        <td></td>
                                                        <td></td>
                                                        {(isPowerEditor || (isEditor && appliedFilters.fecha === now.toLocaleDateString('en-CA'))) && (
                                                            <td>
                                                                <div className="acciones-container">
                                                                    <ButtonUpdate onClick={() => handleActionClick(g.supervisor_id, g.usuario_id)} />
                                                                </div>
                                                            </td>
                                                        )}
                                                    </tr>
                                                );
                                            }

                                            return regsGestor.map((r, idx) => (
                                                <tr key={r.seguimiento_boleta_id}>
                                                    {idx === 0 && (
                                                        <>
                                                            {(!isAnalista && perfilId !== 3) && <td rowSpan={regsGestor.length}>{supervisorName}</td>}
                                                            <td rowSpan={regsGestor.length}>{gestorName}</td>
                                                        </>
                                                    )}
                                                    <td className={getRevisionClass(r.revision_subgerencia)}>{r.dni}</td>
                                                    <td className={getRevisionClass(r.revision_subgerencia)}>
                                                        <span className={`badge ${Number(r.canal_captacion_id) === 2 ? 'bg-success' : 'bg-warning text-dark'}`}>
                                                            {(canalCaptacion.find(c => Number(c.tipo_id) === Number(r.canal_captacion_id))?.descripcion || 'OTRO').toUpperCase()}
                                                        </span>
                                                    </td>
                                                    {idx === 0 && (isPowerEditor || (isEditor && appliedFilters.fecha === now.toLocaleDateString('en-CA'))) && (
                                                        <td rowSpan={regsGestor.length}>
                                                            <div className="acciones-container">
                                                                <ButtonUpdate onClick={() => handleActionClick(r.supervisor_id, r.gestor_id)} />
                                                            </div>
                                                        </td>
                                                    )}
                                                </tr>
                                            ));
                                        });
                                    } else {
                                        if (registros.length === 0) {
                                            return (
                                                <tr>
                                                    <td colSpan="5" className="text-center text-gray-400 py-4">
                                                        No hay datos disponibles para este período.
                                                    </td>
                                                </tr>
                                            );
                                        }

                                        const gestoresIdsEnRegistros = [...new Set(registros.map(r => r.gestor_id))];
                                        return gestoresIdsEnRegistros.map(gid => {
                                            const regsGestor = registros.filter(r => Number(r.gestor_id) === Number(gid));
                                            const firstReg = regsGestor[0];
                                            const supervisorName = (state.user.personal.find(p => Number(p.usuario_id) === Number(firstReg.supervisor_id))?.nombre_completo_usuario || firstReg.nombre_supervisor || 'N/A').toUpperCase();
                                            const gestorName = (state.user.personal.find(p => Number(p.usuario_id) === Number(firstReg.gestor_id))?.nombre_completo_usuario || firstReg.nombre_gestor || 'N/A').toUpperCase();

                                            return regsGestor.map((r, idx) => (
                                                <tr key={r.seguimiento_boleta_id}>
                                                    {idx === 0 && (
                                                        <>
                                                            {(!isAnalista && perfilId !== 3) && <td rowSpan={regsGestor.length}>{supervisorName}</td>}
                                                            <td rowSpan={regsGestor.length}>{gestorName}</td>
                                                        </>
                                                    )}
                                                    <td className={getRevisionClass(r.revision_subgerencia)}>{r.dni}</td>
                                                    <td className={getRevisionClass(r.revision_subgerencia)}>
                                                        <span className={`badge ${Number(r.canal_captacion_id) === 2 ? 'bg-success' : 'bg-warning text-dark'}`}>
                                                            {(canalCaptacion.find(c => Number(c.tipo_id) === Number(r.canal_captacion_id))?.descripcion || 'OTRO').toUpperCase()}
                                                        </span>
                                                    </td>
                                                    {idx === 0 && (isPowerEditor || (isEditor && appliedFilters.fecha === now.toLocaleDateString('en-CA'))) && (
                                                        <td rowSpan={regsGestor.length}>
                                                            <div className="acciones-container">
                                                                <ButtonUpdate onClick={() => handleActionClick(r.supervisor_id, r.gestor_id)} />
                                                            </div>
                                                        </td>
                                                    )}
                                                </tr>
                                            ));
                                        });
                                    }
                                })()}
                            </tbody>
                        </Table>
                    </div>
                )
            }

            <ModalSeguimientoBoleta
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onSave={handleSaveRecord}
                personal={state.user.personal}
                supervisores={supervisores}
                initialSupervisorId={modalInitialData.supervisorId}
                initialGestorId={modalInitialData.gestorId}
                initialDnis={modalInitialData.initialDnis}
                perfilId={perfilId}
            />
        </div >
    );
}

export default SeguimientoBoletaProspecto;